var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export var LoadingContext = React.createContext(null);
export var LoaderProvider = function (_a) {
    var children = _a.children;
    var _b = __read(React.useState(0), 2), loading = _b[0], setLoading = _b[1];
    return (_jsxs(LoadingContext.Provider, __assign({ value: {
            loading: loading,
            setLoading: setLoading,
        } }, { children: [_jsx("div", __assign({ className: "loader-container ".concat(loading ? 'active' : '') }, { children: _jsxs("div", __assign({ className: "loader-block" }, { children: [_jsx("div", __assign({ className: "loader-title" }, { children: "loading" })), _jsx(Spinner, {})] })) })), children] })));
};
export var incLoading = function (p) { return p + 1; };
export var decLoading = function (p) { return p - 1; };
export var useLoading = function () {
    var context = React.useContext(LoadingContext);
    if (context === null) {
        throw new Error("useLoading must be used with a LoadingProvider");
    }
    return context;
};
export var Spinner = function () {
    return (_jsxs("div", __assign({ className: "spinner" }, { children: [_jsx("span", { className: "line line-1" }), _jsx("span", { className: "line line-2" }), _jsx("span", { className: "line line-3" }), _jsx("span", { className: "line line-4" }), _jsx("span", { className: "line line-5" }), _jsx("span", { className: "line line-6" }), _jsx("span", { className: "line line-7" }), _jsx("span", { className: "line line-8" }), _jsx("span", { className: "line line-9" })] })));
};
